import { render } from "./PaymentReceiptDetailTabDetail.vue?vue&type=template&id=c702307a&scoped=true"
import script from "./PaymentReceiptDetailTabDetail.vue?vue&type=script&lang=js"
export * from "./PaymentReceiptDetailTabDetail.vue?vue&type=script&lang=js"

import "./PaymentReceiptDetailTabDetail.vue?vue&type=style&index=0&id=c702307a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c702307a"]])

export default __exports__